import React from "react"
import wdayMap from "../Utils/day_of_week"
import * as styles from "./Styles/Information.module.scss"
import { displayClosingTime } from "../Utils/business_hour"

const CreativeCommonsLicense = (props) => {
  return (
    <p className={styles.license}>
      <span>
        {`このサービスは以下の著作物を改変して利用しています。${props.license.licensor}`}
      </span>
      {props.license.url && (
        <React.Fragment>
          <span>、</span>
          <a href={props.license.url} target="_blank">
            {props.license.linkText}
          </a>
        </React.Fragment>
      )}
    </p>
  )
}

const BusinessHours = (props) => {
  const hoursMap = {}
  props.hours.forEach((h) => {
    if (wdayMap[h.dayOfWeek] == undefined) {
      return
    }
    const hoursArray = hoursMap[wdayMap[h.dayOfWeek]] || []
    if (h.openingTime == null) {
      hoursArray.push("24時間営業")
    } else {
      const closingTime = displayClosingTime(h.openingTime, h.closingTime)
      hoursArray.push(`${h.openingTime}〜${closingTime}`)
    }
    hoursMap[wdayMap[h.dayOfWeek]] = hoursArray
  })
  props.holidays.forEach((h) => {
    if (wdayMap[h.dayOfWeek] == undefined) {
      return
    }
    const hoursArray = hoursMap[wdayMap[h.dayOfWeek]] || []
    hoursArray.push("定休日")
    hoursMap[wdayMap[h.dayOfWeek]] = hoursArray
  })
  return (
    <div className={styles.businessHours}>
      {Object.values(wdayMap).map((key) => (
        <React.Fragment key={key}>
          {hoursMap[key] && (
            <dl>
              <dt>{key.charAt(0)}</dt>
              <dd>{hoursMap[key].join(" ")}</dd>
            </dl>
          )}
        </React.Fragment>
      ))}
      {props.annotation && <div>{props.annotation}</div>}
    </div>
  )
}

const Info = (props) => {
  const mapLink = `https://www.google.com/maps/dir/?api=1&destination=${props.place.address}`
  return (
    <div>
      <h2 className={styles.header}>基本情報</h2>
      <table className={styles.infoTable}>
        <tbody>
          <tr>
            <th>名前</th>
            <td>{props.place.name}</td>
          </tr>
          {props.place.description && (
            <tr>
              <th>詳細</th>
              <td>{props.place.description}</td>
            </tr>
          )}
          {props.place.categories.length > 0 && (
            <tr>
              <th>カテゴリ</th>
              <td>{props.place.categories.join("・")}</td>
            </tr>
          )}
          {props.place.address && (
            <tr>
              <th>住所</th>
              <td>
                {props.place.zipCode && <span>〒{props.place.zipCode} </span>}
                <span>{props.place.address}</span>
                <a href={mapLink} className={styles.mapLink} target="_blank">
                  <div>ルートを調べる</div>
                </a>
              </td>
            </tr>
          )}
          {props.place.phoneNumber && (
            <tr>
              <th>電話番号</th>
              <td>
                <a href={`tel:${props.place.phoneNumber}`}>
                  {props.place.phoneNumber}
                </a>
              </td>
            </tr>
          )}
          {props.place.url && (
            <tr>
              <th>外部サイト</th>
              <td>
                <a href={props.place.url} target="_blank">
                  {props.place.url}
                </a>
              </td>
            </tr>
          )}
          {(props.place.businessHours.length > 0 ||
            props.place.holidays.length > 0 ||
            props.place.businessHourAnnotation) && (
            <tr>
              <th>営業時間</th>
              <td>
                <BusinessHours
                  holidays={props.place.holidays}
                  hours={props.place.businessHours}
                  annotation={props.place.businessHourAnnotation}
                />
              </td>
            </tr>
          )}
          {props.place.access && (
            <tr>
              <th>アクセス</th>
              <td>{props.place.access}</td>
            </tr>
          )}
        </tbody>
      </table>
      {props.place.licenses && (
        <div>
          {props.place.licenses.map((l, i) => (
            <div key={i}>
              {l.type == "creative_commons" && (
                <CreativeCommonsLicense license={l} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Info
